var map = {
	"./account.js": "Rlrl",
	"./ad.js": "C2sP",
	"./audit.js": "CmfL",
	"./authority.js": "M51d",
	"./company.js": "XcxY",
	"./management.js": "jFro",
	"./message.js": "Kfy8",
	"./users.js": "qWdx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bW4F";


//////////////////
// WEBPACK FOOTER
// ./src/router nonrecursive ^(?!\.\/index).*\.js$
// module id = bW4F
// module chunks = 24